<template>
  <div class="Header">
    <div class="header-return-btn" @click="back" v-if="!inShare">&lt;</div>
    <div class="logo" :class="{app: !inShare}"></div>
    <a href="#" v-if="!inShare" @click="showMyRedpacket">
      <div class="header-btn my-redpacket">我的红包</div>
    </a>
    <div class="header-btn active-rule" @click="showRule">活动规则</div>
    <div class="rule" v-show="isRuleShow">
      <div class="rule-mask" @click="closeRule"></div>
      <div class="rule-borad">
        <div class="rule-borad-text">
          一、活动时间：
          <br>2019年1月28日-2019年2月14日（以下简称活动时间）；
          <br>二、活动对象：
          <br>工银e生活注册用户；
          <br>三、活动内容：
          <br>1. 用户登录工银e生活-热门活动可参与活动，完成小游戏后获得1个随机红包。
          <br>2. 当日未参与活动的用户于当日第一次帮好友拆红包成功可获得1个助力红包，至工银e生活参与活动即可激活并提升红包金额；红包完全拆开需有5个好友帮忙拆，当日24点前未拆完的红包作废。
          <br>3. 每名用户每天可帮助3名好友拆1次红包，活动期间最多可帮同一好友拆10次红包。
          <br>4. 拆开的每个红包的金额将以工银e生活电子券的形式最晚于活动结束后5个工作日发放至工银e生活优惠券账户中。用户可在工银e生活app-我的-票券-电子券中查看，电子券不可叠加使用。
          <br>5. 同一用户每天可参与1次活动（同一工银e生活帐号、同一 手机号均视为同一用户）获得1个红包，红包以当日第一次获得的为准。
          <br>6. 奖品说明：
          <br>（1）2019元新春拆红包电子券：该券仅限工银e生活“手机数码、e爆品、手机充值、演出票务”场景使用；具体电子券张数和使用规则以电子券使用说明为准。
          <br>（2）188元新春拆红包电子券：该券仅限工银e生活“手机数码、e爆品、手机充值、演出票务”场景使用；具体电子券张数和使用规则以电子券使用说明为准。
          <br>（3）88.88元新春拆红包电子券：该券仅限工银e生活“手机数码、e爆品、手机充值、演出票务”场景使用；具体电子券张数和使用规则以电子券使用说明为准。
          <br>（4）68.88元新春拆红包电子券：用户将分别获得一张50元电子券、一张18.88元电子券。其中50元电子券仅限工银e生活“手机数码-Apple产品”场景使用，18.88元电子券仅限工银e生活“手机数码、e爆品、手机充值、演出票务”场景使用；具体电子券张数和使用规则以电子券使用说明为准。
          <br>（5）58.88元新春拆红包电子券：用户将分别获得一张50元电子券、一张8.88元电子券。其中50元电子券仅限工银e生活“手机数码-Apple产品”场景使用，8.88元电子券仅限工银e生活“手机数码、e爆品、手机充值、演出票务”场景使用；具体电子券张数和使用规则以电子券使用说明为准。
          <br>（6）56.66元新春拆红包电子券：用户将分别获得一张50元电子券、一张6.66元电子券。其中50元电子券仅限工银e生活“手机数码-Apple产品”场景使用，6.66元电子券仅限工银e生活“手机数码、e爆品、手机充值、演出票务”场景使用；具体电子券张数和使用规则以电子券使用说明为准。
          <br>（7）50元新春拆红包电子券：该券仅限工银e生活“手机数码-Apple产品”场景使用；具体电子券张数和使用规则以电子券使用说明为准。
          <br>7.注意事项：
          <br>（1）活动奖品数量有限，先到先得，抢完为止。
          <br>（2）电子券仅限使用1次，购买订单一旦生成则视为电子券已使用，若支付失败，电子券将于30分钟内退回，用户可在“我的”-“票券”-“电子券”中查看。
          <br>（3）如发生退货，退款金额应为实际支付金额，电子券不予补发；
          <br>（4）如有任何疑义，请于活动结束后15个工作日内提出，逾期不予受理。
          <br>（5）本活动若出现非正当方式获取奖励的行为，一经查实将取消活动资格和待发奖励，情节严重者将被追究法律责任。
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isRuleShow: false
    };
  },
  props: {
    inShare: Boolean
  },
  methods: {
    showRule() {
      this.isRuleShow = true;
    },
    closeRule() {
      this.isRuleShow = false;
    },
    back() {
      window.hybrid_app.back();
    },
    showMyRedpacket(e) {
      e.preventDefault();
      this.$router.replace('/my');
      fiboSDK.btnClick('app-toMyRp-btn', '我的红包');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index.scss';
.Header {
  margin-top: 2px;
  width: 100vw;
  position: relative;
  z-index: 99;
  .header-return-btn {
    color: #f6d478;
    width: 10vw;
    @include set-property(font-size, 55);
    font-weight: 600;
    @include set-lt(10, 0);
  }
  .logo {
    @include set-image('../assets/images/logo.png');
    @include set-size(284, 70);
    @include set-lt(10, 0);
    &.app {
      @include set-lt(80, 0);
    }
  }
  .header-btn {
    @include set-image('../assets/images/header-btn.png');
    @include set-size(131, 43);
    @include set-property(font-size, 21.5);
    @include set-property(line-height, 44);
    font-weight: 600;
    color: #95020c;
    &.my-redpacket {
      @include set-lt(460, 14);
    }
    &.active-rule {
      @include set-lt(600, 14);
    }
  }
  .rule {
    &-mask {
      @include set-image('../assets/images/mask.png');
      background-size: 100% 100%;
      position: fixed;
      width: 100vw;
      height: 100vh;
      top: 0;
      left: 0;
      z-index: 20;
    }
    &-borad {
      @include set-image('../assets/images/home-rule.png');
      @include set-size(561, 710);
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      z-index: 30;
      &-text {
        @include set-property(font-size, 22);
        @include set-lt(48, 111);
        @include set-size(484, 483);
        text-align: start;
        overflow: scroll;
        padding: 8px;
      }
    }
  }
}
</style>


